export default {
    path: 'shipping',
    component: () => import('../Shipping.vue'),
    children: [
        {
            path: '',
            name: 'Vận chuyển',
            component: () => import('../table/Table.vue'),
        }
    ]
}